/* eslint-disable react/jsx-one-expression-per-line */
/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { renderDefaultError, renderDefaultLoading } from '@exo/frontend-common-utils';
import { useOrderDetails } from '../../hooks/useOrderDetail';
import { useOrderTrackingDetails } from '../../hooks/useOrderTracking';
import { useEffect, useState } from 'react';
import { useGetAddress } from '../../hooks/useGetAddress';



export const OrderDetailsContainer = ({
  orderId,
  render,
  renderLoading = renderDefaultLoading,
  renderError = renderDefaultError,
}: any) => {
  const { data, loading, error } = useOrderDetails({ orderId: orderId });
  const [addressId,setaddressID] = useState('')
  const [skip,setSkip] =useState(true)
  const [dateofBirth,setDateOfBirth] = useState('')
  const {addressData,refetch} = useGetAddress(addressId,skip)
  const status = data?.me?.orderDetail?.status;
  const makeAddressCall = async() => {
    setSkip(false)
    await refetch()
    setSkip(true)
  }
  const { getOrderTrackingDetails, trackingOrderDetail } = useOrderTrackingDetails();

  useEffect(() => {
    if(process.env.APP_NAME === "TDCAPM" && !location.pathname.includes("confirmation")){
      getOrderTrackingDetails({ variables: { orderId } });
    }
  }, [status, orderId, getOrderTrackingDetails,trackingOrderDetail?.data]);
  useEffect(() => {
    if(data) {
      if(addressId === ""){
        setaddressID(data?.me?.orderDetail.billingAddress?.id)
      }
    }
  },[data])
  useEffect(() => {
    if(addressId!=="" && process.env.APP_NAME === "TDUSBN"){
      makeAddressCall()
    }
  },[addressId])
  useEffect(() => {
    if(addressData){
      setDateOfBirth(addressData.customerGetAddress.dateOfBirth)
    }
  },[addressData])
  if (loading || trackingOrderDetail?.loading) return renderLoading();
  if (error || trackingOrderDetail?.error) return renderError(error);

  return render({ orders: {...data?.me?.orderDetail,billingAddress:{...data?.me?.orderDetail.billingAddress,dateOfBirth:dateofBirth}}, OrderTracking: trackingOrderDetail?.data });
};
